import React, { useState } from 'react';
import { IS_LIMIT_REACHED_KEY_ERROR, IS_NOT_MULTIPLE_KEY_ERROR, cartManager, sortByQuantity } from './cartManager';
import { MinusIcon } from './MinusIcon';
import { PlusIcon } from './PlusIcon';

const findMinQty = (priceObj) => {
    const sortedQuantities = Array.isArray(priceObj?.quantities) ? [...priceObj.quantities].sort(sortByQuantity) : [];
    return sortedQuantities[0]?.minQty ?? 1;
};

const CountButton = ({ price, originalPrice, duty }) => {
    const [productCount, setProductCount] = useState(0);
    const [error, setError] = useState('');

    const setCountWithDuty = (count) => {
        const priceWithDuty = { ...price, duty }; // Добавляем пошлину
        const result = cartManager.setProductsCount(priceWithDuty, count);
        if (result.error) {
            setError(result.error);
        }
    };

    const enterProductCount = (e) => {
        setError('');
        const value = +e.target.value;
        if (value >= 0) {
            setProductCount(value);
            setCountWithDuty(value);
        }
    };

    const increaseProductCount = () => {
        setError('');
        const step = findMinQty(price);
        const currentCount = +productCount === 0 ? step : +productCount + step;
        setProductCount(currentCount);
        setCountWithDuty(currentCount);
    };

    const decreaseProductCount = () => {
        setError('');
        const step = findMinQty(price);
        const newCount = +productCount - step;
        setProductCount(newCount);
        setCountWithDuty(newCount);
    };

    return (
        <td className="product-price__table-item product-price__table-item_height">
            <div className={`product-price__table-block ${error ? 'product-price__table-item_error' : ''} ${originalPrice.stockNumber === 0 ? 'disabled' : ''}`}>
                <span className="product-price__table-button product-price__table-button_left"
                    onClick={() => +productCount === 0 ? null : decreaseProductCount()}>
                    {originalPrice.stockNumber !== 0 ? 
                        <MinusIcon nameOfClass={`product-price__table-icon ${+productCount !== 0 ? '' : 'product-price__table-icon_disabled'}`} /> 
                        : 
                        ''}
                </span>
                {originalPrice.stockNumber !== 0 ?
                    <input className="product-price__table-quantity"
                        value={productCount}
                        onChange={enterProductCount} 
                        onBlur={() => productCount === '' ? setProductCount(0) : null}
                    />
                    :
                    <p className='product-price__table-quantity_disabled'>Нет в наличии</p>
                }
                <span 
                    className="product-price__table-button"
                    onClick={() => {
                        const step = findMinQty(price);
                        const nextCount = +productCount === 0 ? step : (+productCount + step);
                        return nextCount <= originalPrice.stockNumber ? increaseProductCount() : null;
                    }}>
                    {originalPrice.stockNumber !== 0 ? 
                        (() => {
                            const step = findMinQty(price);
                            const nextCount = +productCount === 0 ? step : (+productCount + step);
                            return (
                                <PlusIcon nameOfClass={`product-price__table-icon ${nextCount <= originalPrice.stockNumber ? '' : 'product-price__table-icon_disabled'}`} />
                            );
                        })()
                        : 
                        ''}
                </span>
                {error ? 
                    <p className="product-price__table-error">
                        {error === IS_LIMIT_REACHED_KEY_ERROR ? 
                            `В наличии ${originalPrice.stockNumber} шт.` : 
                            (error === IS_NOT_MULTIPLE_KEY_ERROR
                                ? `Кратно ${findMinQty(originalPrice)} шт.`
                                : `Заказ от ${findMinQty(originalPrice)} шт.`)}
                    </p> 
                    : 
                    ''} 
            </div>
        </td>
    );
};

export default CountButton;